import Axios from "axios";

export const SelectReglement = (a, b, c, d, e,f,g) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/REGCLIs?coddos=${a}&serveur=${b}&vendeur=${c}&grp=${d}&user=${e}&pwd=${f}&database=${g}`
    ).then((response) => {
      return dispatch({ type: "REG_SELECT", payload: response.data });
    });
  };
};
